import { SearchQueryOrderDirection } from "types/generated";

export const TOFU_WORKSPACES_FILTER_TYPE = "tofu-workspaces";
export const INITIAL_SORT_OPTION = "name";
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;
